import * as React from "react";

import { LinkButton } from "../Component/LinkButton"
import { side } from "../Component/components";

export class Rapport extends React.Component<any, any>  {

    constructor(props: any) { super(props); }

    render() {
        return side("Rapporter",
            <ul>
                <li><LinkButton to="/api/Excel/PoliserTilExcel">Alle poliser</LinkButton></li>
                <li><LinkButton to="/api/Excel/FakturaPoliserTilExcel">Alle fakturaer med tilhørende poliser</LinkButton></li>
                <li><LinkButton to="/api/Excel/AktorerTilExcel">Alle aktører</LinkButton></li>
            </ul>);
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Rapport/Rapport.tsx